/*
============================================
CLUSTER A/B TEST: Cart Trust Elements
Test ID: bbf3001c-f097-475e-b582-a0724cdedd35
Control Variant ID: cf579f80-0773-4455-9477-d84073b4e7a1
Treatment Variant ID: c7e94e39-b691-4521-9796-bb8bc60cae4c
============================================
*/
(function() {
  var TEST_ID = 'bbf3001c-f097-475e-b582-a0724cdedd35';
  var CONTROL_VARIANT_ID = 'cf579f80-0773-4455-9477-d84073b4e7a1';
  var TREATMENT_VARIANT_ID = 'c7e94e39-b691-4521-9796-bb8bc60cae4c';
  var currentVariant = 'control';

  function getAssignments() {
    if (window.cluster_ctx && Array.isArray(window.cluster_ctx.assignments)) {
      return window.cluster_ctx.assignments;
    }
    if (window.__clusterDebug && Array.isArray(window.__clusterDebug.assignments)) {
      return window.__clusterDebug.assignments;
    }
    return null;
  }

  function getAssignedVariant() {
    var assignments = getAssignments();
    if (!assignments) return null;

    for (var i = 0; i < assignments.length; i++) {
      var assignment = assignments[i];
      if (!assignment || assignment.testId !== TEST_ID) continue;

      if (assignment.variantId === TREATMENT_VARIANT_ID) return 'treatment';
      if (assignment.variantId === CONTROL_VARIANT_ID) return 'control';

      if (assignment.variant && typeof assignment.variant.isControl === 'boolean') {
        return assignment.variant.isControl ? 'control' : 'treatment';
      }
    }

    return null;
  }

  function applyVariant(variant) {
    currentVariant = variant === 'treatment' ? 'treatment' : 'control';
    var isTreatment = currentVariant === 'treatment';
    document.documentElement.classList.toggle('is-cart-trust-treatment', isTreatment);
  }

  function resolveAndApply() {
    var assignedVariant = getAssignedVariant();
    applyVariant(assignedVariant || 'control');
    return assignedVariant;
  }

  window.isCartTrustTreatment = function() {
    return currentVariant === 'treatment';
  };

  resolveAndApply();

  var attempts = 0;
  var maxAttempts = 80;
  var pollInterval = setInterval(function() {
    attempts += 1;
    var assignedVariant = getAssignedVariant();
    if (assignedVariant) {
      applyVariant(assignedVariant);
      clearInterval(pollInterval);
      return;
    }
    if (attempts >= maxAttempts) {
      clearInterval(pollInterval);
    }
  }, 250);
})();
